<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              v-if="!isWx"
            />
            <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="itemName"
                placeholder="搜索"
                @keyup.enter="submit"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="" />
        </div>
        <div class="inner bor_b" v-for="(item, index) in list" :key="index">
          <div class="data_modular">
            <div class="top m_flex_box flex_vc flex_jz">
              <h5 class="line_comp1">
                {{ item.itemName ? item.itemName : "-" }}
              </h5>
              <!-- <p><span>开始报名</span><span></span></p> -->

              <p>
                <span v-if="item.jdStatus == '报名中'"
                  >开始报名:{{
                    (item.buyerHouseRatio * 100).toFixed(2) + "%"
                  }}</span
                >
                <span v-if="item.jdStatus == '摇号公示'">摇号公示</span>
                <span v-if="item.jdStatus == '摇号公示'"
                  >&nbsp;&nbsp;|&nbsp;&nbsp;</span
                >
                <span
                  v-if="
                    item.buyerHouseRatio >= '2' && item.jdStatus == '摇号公示'
                  "
                  >公证处摇号</span
                >
                <span
                  v-if="
                    item.buyerHouseRatio < '2' && item.jdStatus == '摇号公示'
                  "
                  >开发商自行销售</span
                >
                <span v-if="item.jdStatus == '认购公示'">认购公示</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">项目当前状态:</span>
                <span
                  v-if="
                    item.jdStatus == '摇号公示' && item.buyerHouseRatio >= '2'
                  "
                  >报名人数大于等于可售商品房住宅数量的2倍，将由公证处进行摇号确认购房名单及选房顺序</span
                >
                <span v-if="item.jdStatus == '报名中'"
                  >当前项目处于报名阶段中</span
                >
                <span
                  v-if="
                    item.jdStatus == '摇号公示' && item.buyerHouseRatio < '2'
                  "
                  >报名人数小于可售商品房住宅数量的2倍，将交由开发企业自行销售</span
                >
                <span v-if="item.jdStatus == '认购公示'"
                  >开发企业根据选房序号进行房源的认购</span
                >
              </p>
            </div>
            <div class="row f_flex">
              <p class="m_flex_box" style="flex: 1">
                <span class="f_title">房源套数:</span>
                <span>{{ item.kszzCount ? item.kszzCount : "-" }}</span>
              </p>
              <p class="m_flex_box" style="flex: 1">
                <span class="f_title">报名人数:</span>
                <span>{{ item.bmCount ? item.bmCount : "-" }}</span>
              </p>
              <p class="m_flex_box" style="flex: 1">
                <span class="f_title">报名比例:</span>
                <span>{{ (item.buyerHouseRatio * 100).toFixed(2) + "%" }}</span>
              </p>
            </div>
            <div class="row f_flex">
              <p class="m_flex_box">
                <span class="f_title">我的报名序号:</span>
                <span>{{ item.bmSeq ? item.bmSeq : "-" }}</span>
              </p>
              <p class="m_flex_box">
                <span class="f_title">我的报名时间:</span>
                <span>{{ item.createDate ? item.createDate : "-" }}</span>
              </p>
            </div>
            <div class="row f_flex">
              <p class="m_flex_box">
                <span class="f_title">我的人员类型:</span>
                <span>{{ item.talentType ? item.talentType : "-" }}</span>
              </p>
              <p class="m_flex_box">
                <span class="f_title">婚姻状况:</span>
                <span>{{ item.marryStatus ? item.marryStatus : "-" }}</span>
              </p>
            </div>

            <div class="row f_flex">
              <p class="m_flex_box">
                <span class="f_title">我的摇号结果:</span>
                <span>{{ item.seq ? item.seq : "-" }}</span>
              </p>
            </div>
          </div>
          <div class="data_modular f_line">
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">开发企业:</span>
                <span>{{ item.corpName ? item.corpName : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">项目地址:</span>
                <span>{{ item.itemSite ? item.itemSite : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">预售范围:</span>
                <span>{{ item.preItemName ? item.preItemName : "-" }}</span>
              </p>
            </div>
          </div>
          <div class="data_modular f_line">
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">项目报名开始时间:</span>
                <span>{{ item.bmkssj ? item.bmkssj : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">项目报名结束时间:</span>
                <span>{{ item.bmjssj ? item.bmjssj : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">公证处摇号时间:</span>
                <span>{{ item.jhyhsj ? item.jhyhsj : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">认购开始时间:</span>
                <span>{{ item.fwrgsj ? item.fwrgsj : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">无房验证状态:</span>
                <span>{{ item.houseStatus ? item.houseStatus : "-" }}</span>
                <!-- <span>{{
                  item.houseStatus == 0
                    ? "无需验证"
                    : item.houseStatus == 1
                    ? "待确认"
                    : item.houseStatus == 2
                    ? "通过"
                    : "未通过"
                }}</span> -->
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">无房验未通过原因:</span>
                <span>{{
                  item.houseCheckInfo ? item.houseCheckInfo : "-"
                }}</span>
              </p>
            </div>
          </div>
          <div
            class="data_modular f_btn_line"
            v-if="
              (item.dataStatus == 1 && quxiao(item.bmjssj)) ||
              item.dataStatus == 0
            "
          >
            <p
              class="f_btn"
              v-if="item.dataStatus == 1 && quxiao(item.bmjssj)"
              @click="cancel(item.id)"
            >
              取消报名
            </p>
            <p class="f_btn_h" v-if="item.dataStatus == 0">已取消</p>
          </div>
          <div class="data_modular f_line_o" v-if="item.jdStatus == '认购公示'">
            <!-- <div class="row">
              <p class="m_flex_box">
                <span class="f_title">认购进度:</span>
                <span>{{ item.preItemName ? item.preItemName : "-" }}</span>
              </p>
            </div> -->
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">我的认购状态:</span>
                <span>{{ item.choiceType ? item.choiceType : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">我的认购时间:</span>
                <span>{{ item.preBuyDate ? item.preBuyDate : "-" }}</span>
              </p>
            </div>
            <div class="row">
              <p class="m_flex_box">
                <span class="f_title">我的认购房源:</span>
                <span>{{ item.houseInfo ? item.houseInfo : "-" }}</span>
              </p>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="xzqh_name"
        :columns="xzqhArray"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup> -->
  </div>
</template>

<script>
import topHeader from "@/components/header";
import qs from "qs";
export default {
  data() {
    return {
      isWx: sessionStorage.getItem("isWx") || false,
      isApp: sessionStorage.getItem("isApp") || false,
      btnStyle: true,
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      pageIndex: 1,
      timer: null,
      itemName: "",
      // showPicker: false,
      // xzqhArray: [],
      xzqhDefault: this.main.getHostArea(),
      items: "",
      area: "",
      xzqh: this.main.getHostArea(),
      token: "",
    };
  },
  inject: ["reload"],
  created() {
    this.assignmentTooken();
  },
  mounted() {
    this.getArea();
    // var Img = this.logoImg;
    // var url = window.location.href;
    // var hosts = url.split("/#/")[0]; //获取域名加打包文件夹名称
    // var shareImg = hosts.concat("/" + Img);
    // this.$share(
    //   "徐州市商品房预售进度",
    //   "新建商品房预售办理进度实时查看，开盘进度及时掌握",
    //   shareImg
    // );
  },
  methods: {
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    assignmentTooken() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        var ua = navigator.userAgent;
        var uaList=ua.split(" ")
        var token=""
        for(var i=0;i<uaList.length;i++){
          if(uaList[i].indexOf('token')>-1){
            token=uaList[i].split('=')[1]
          }
        }
        this.token = token;
      } else {
        if ((this.isWx && this.isWx != "false") || this.isWx == "true") {
          if (window.sessionStorage.getItem("wxAppToken")) {
            this.token = sessionStorage.getItem("wxAppToken");
          }
        } else {
          if (JSON.parse(window.localStorage.getItem("tokenObj"))) {
            this.token = JSON.parse(localStorage.getItem("tokenObj")).appToken;
          }
        }
      }
    },
    cancel(id) {
      this.$dialog
        .confirm({
          confirmButtonColor: "#2F72F5",
          title: "提示",
          message: "您确定取消报名？请谨慎操作",
        })
        .then(() => {
          this.$http
            .post(
              "house/api/ysbm/cancelbmsq.do",
              qs.stringify({
                appToken: this.token,
                gfbmId: id,
              })
            )
            .then((res) => {
              if (res.code == "000") {
                this.$dialog
                  .alert({
                    title: "提示",
                    message: "确认已取消",
                  })
                  .then(() => {
                    this.reload();
                  });
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    quxiao(str) {
      var startDate = str.replace(new RegExp("-", "gm"), "/");
      var startDateM = new Date(startDate).getTime(); //得到毫秒数
      var newDate = new Date().getTime();
      if (startDateM >= newDate) {
        return true;
      } else {
        return false;
      }
    },
    onRefresh() {
      console.log("refresh");
      this.loading = false;
      this.finished = false;
      this.pageIndex = 1;
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    submit() {
      this.loading = false;
      this.finished = false;
      this.$set(this, "pageIndex", 1);
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    // onConfirm(data) {
    //   this.area = data.xzqh_name;
    //   this.showPicker = false;
    //   this.$set(this, "xzqh", data.xzqh_code);
    //   this.loading = false;
    //   this.finished = false;
    //   this.pageIndex = 1;
    //   this.$set(this, "list", []);
    //   this.onLoad();
    // },
    // 获取默认的行政区划
    getArea() {
      this.$new.post("xzqh/getXzqh.do").then((res) => {
        if (res.obj) {
          if (this.xzqhDefault === "320300") {
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = { xzqh_code: "320300", xzqh_name: "主城区" };
            this.xzqhArray.splice(0, 0, this.items);
            this.area = "主城区";
          } else {
            res.obj.forEach((item) => {
              if (this.xzqhDefault === item.xzqh_code) {
                this.$set(this, "xzqhArray", [item]);
                this.area = item.xzqh_name;
              }
            });
          }
        }
      });
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$http
          .post(
            "house/api/ysbm/grbmjlList.do",
            qs.stringify({
              pageSize: 10,
              pageIndex: this.pageIndex,
              itemName: this.itemName,
              appToken: this.token,
            })
          )
          .then((res) => {
            if (type) {
              this.isLoading = false;
            }
            if (res.code == "000") {
              this.list = this.list.concat(res.rows);
              this.loading = false;
              this.$set(this, "pageIndex", this.pageIndex + 1);
              if (res.rows.length == 0) {
                this.loading = false;
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.main_other {
  margin-top: 20px;
}
.fixed_pad_new {
  padding-top: 1.5rem;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.fixed_top {
  padding-top: 20px;
}
.header_address {
  font-size: 0.28rem;
  font-weight: 600;
  cursor: pointer;
  &.white {
    &:after {
      border-color: #fff transparent transparent transparent;
    }
  }
  &:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.08rem;
    margin-left: 0.1rem;
    margin-top: 0.08rem;
    border-color: #202020 transparent transparent transparent;
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    background-color: #f6f6f6;
    border: 1px solid #f0f0f0;
    border-radius: 0.7rem;
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    width: 4.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.bg_gray {
  min-height: 100vh;
  background-color: #f5f5f5;
}
.inner {
  padding: 0.24rem 0.24rem;
  background-color: #fff;
  .f_line {
    border-top: 1px solid #f5f5f5;
    padding-top: 0.2rem;
    margin-top: 0.2rem;
  }
  .f_line_o {
    border-top: 1px solid #f5f5f5;
    padding-top: 0.2rem;
  }
  .f_btn_line {
    padding: 0.15rem 0;
    border-top: 1px solid #f5f5f5;
    margin-top: 0.2rem;
    overflow: hidden;
    p {
      padding-right: 1.5rem;
    }
    .f_btn {
      width: 1rem;
      text-align: center;
      float: right;
      padding: 0.1rem 0.2rem;
      background: #007fff;
      color: #fff;
      border-radius: 5px;
    }
    .f_btn_h {
      width: 1rem;
      text-align: center;
      float: right;
      padding: 0.1rem 0.2rem;
      background: #a1a1a1;
      color: #fff;
      border-radius: 5px;
    }
  }
  .data_modular {
    .f_flex {
      display: flex;
      p:first-child {
        flex: 0 1 40%;
      }
      p:last-child {
        flex: 1;
      }
    }

    .f_title {
      word-break: keep-all;
      white-space: nowrap;
      color: #808080;
    }
  }
}
.top {
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.2rem;
  margin-bottom: 0.12rem;
  h5 {
    font-size: 0.26rem;
    font-weight: 800;
    max-width: 70%;
  }
  p {
    font-size: 0.24rem;
    span {
      color: #2f72f5;
    }
  }
}
.row {
  &:last-child {
    padding-bottom: 0;
  }
  padding-bottom: 0.12rem;
  p {
    line-height: 0.36rem;
    color: #808080;
    font-size: 0.24rem;
    span {
      max-width: 80%;
      color: #101010;
    }
  }
}
.bor_b {
  border-bottom: 0.3rem solid #f5f5f5;
}
</style>